import { Access, AccessCase, AccessCaseNotice, User } from '@prisma/client';
import { Alert, Descriptions, DescriptionsProps, Space, Spin } from 'antd';
import { get } from 'lodash';

import { formatIsoDate } from '@app/utils-agnostic';

import { useAccessCaseFindUnique } from '../data';

import { NoticeTable } from './notice-table';

type DataType = AccessCase & { access: Access; notices: AccessCaseNotice[]; user: User };

export type CaseViewPanelProps = {
  caseId: number;
};

export const CaseViewPanel = ({ caseId }: CaseViewPanelProps) => {
  const { data, error, isPending, isFetching } = useAccessCaseFindUnique<DataType>({
    where: {
      id: caseId,
    },
    include: {
      access: true,
      notices: true,
      user: true,
    },
  });

  if (isPending || isFetching) {
    return <Spin style={{ width: '100%', minHeight: 300 }} />;
  }

  if (error) {
    return <Alert message="Error" description={get(error, ['message'])} type="error" showIcon />;
  }

  const items: DescriptionsProps['items'] = [
    {
      key: 'user',
      label: 'User',
      children: data?.user.name,
    },
    {
      key: 'status',
      label: 'Status',
      children: data ? data.status : undefined,
    },
    {
      key: 'access',
      label: 'Access',
      children: data ? data.access.name : undefined,
    },
    {
      key: 'createdOn',
      label: 'Created On',
      children: data ? formatIsoDate(data.createdOn.toString()) : undefined,
    },
  ];

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Descriptions bordered items={items} column={2} />
      <NoticeTable notices={data?.notices || []} />
    </Space>
  );
};
